module.exports = __webpack_public_path__ + "3e95d994ef527f2914f0d602e7932339.png";